import { Button, ButtonProps, CircularProgress } from "@mui/material"
import { useStyles } from "./styles"

interface LoadingButtonProps extends ButtonProps {
    pending?: boolean
}

export const LoadingButton = ({ children, className, disabled, pending, ...props }: LoadingButtonProps) => {
    const { classes, cx } = useStyles()

    return (
        <Button disabled={disabled || pending} className={cx(classes.button, className)} {...props}>
            <span className={cx({ [classes.buttonText__pending]: pending })}>{children}</span>
            {pending && <CircularProgress className={classes.buttonProgress} size={20} />}
        </Button>
    )
}
